<template>
  <div id="app">
    <div class="main">
      <div class="active" @click="turnCard(0)">
        <div v-if="active">
          <div 
            class="card"
            :class="{
              'two-cards': deck.length === 1, 
              'one-card': deck.length === 0, 
            }"
          >
            <img :src="activeImage">
          </div>
        </div>
      </div>
      <div class="choise" @click="active = 'clubs'">
        <img src='@/assets/clubs.png'>
      </div>
      <div class="choise" @click="active = 'harts'">
        <img src='@/assets/harts.png'>
        </div>
      <div class="choise" @click="active = 'spades'">
        <img src='@/assets/spades.png'>
        </div>
      <div class="choise" @click="active = 'diamonds'">
        <img src='@/assets/diamonds.png'></div>
    </div>
  </div>
</template>

<style>

  html, body, #app {
    height: 100%;
    width: 100%;
    padding: 0;
    margin: 0;
  }

  body {
    /* background: rgb(5,79,0); */
    /* background: radial-gradient(circle, rgba(5,79,0,1) 0%, rgba(9,148,0,1) 100%); */
    background: radial-gradient(circle, rgba(11,176,0,1) 0%, rgba(33,149,25,1) 100%);
  }

  .main {
    height: 100%;
    width: 100%;
    display: grid;
    grid-template-columns: repeat(4, 25%);
    grid-template-rows: 1fr 60px;
  }

  .active {
    grid-column: 1 / 5;
    text-align: center;
  }

  .active img {
    max-width: 90%;
    max-height: 50%;
    margin: 0;
  }

  .choise {
    text-align: center;
    background: #ffffff;
  }
  
  img {
    margin-top: 10%;
    max-height: 75%;
    display: inline-block;
  }

  .card,
  .card:before,
  .card:after {
    margin-top: 150px;
    width: 275px;
    height: 370px;
    margin-left: auto;
    margin-right: auto;
    background: #ffffff;
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 2px 2px 15px 0px rgba(0,0,0,0.34);
    z-index: 2;
  }

  .card:not(.one-card):before,
  .card:not(.one-card):not(.two-cards):after {
    content: '';
    position: absolute;
    z-index: -1 !important;
    
  }

  .card:before {
    transform: rotate(3deg);
    top: 10px;
  }

  .card:after {
    transform: rotate(-2deg);
    top: 15px;
  }
</style>

<script>

const SUITS = [
  'harts',
  'diamonds',
  'clubs',
  'spades',
]

export default {
  name: 'App',

  data() {
    return {
      active: null,
      deck:   [],
    }
  },

  computed: {
    activeImage() {

      var images = require.context('@/assets/', false, /\.png$/)
      return images('./' + this.active + ".png")
    }
  },

  mounted() {
    this.shuffleDeck();
    console.log(this.deck);
  },

  methods: {
    async turnCard() {
      if (this.deck.length === 0) {
        this.shuffleDeck();
      }
      await this.animate();
      this.active = this.deck.shift();
    },

    async animate() {
      for (let i = 0; i < 10; i++) {
        let currentActiveIndex = SUITS.indexOf(this.active);
        let choises            = JSON.parse(JSON.stringify(SUITS));
        choises.splice(currentActiveIndex, 1);
        this.active = choises[Math.floor(Math.random() * choises.length)];

        await new Promise(resolve => setTimeout(resolve, 100));
      }
    },

    shuffleDeck() {
      let newDeck = [];
      for (let i = 0; i < 5; i++) {
        for (let suit of SUITS) {
          newDeck.push(suit);
        }
      }
      let currentIndex = newDeck.length
      let randomIndex;

      while (currentIndex != 0) {

        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;

        [newDeck[currentIndex], newDeck[randomIndex]] = [
          newDeck[randomIndex], newDeck[currentIndex]];
      }

      this.deck = newDeck;
    },
  }
}
</script>
